<template>
  <!-- eslint-disable -->
  <div>
    <b-overlay variant="white" :show="showLoading" spinner-variant="primary" blur="0" opacity=".75" rounded="sm">
      <bandeja-filters ref="filters" />
      <b-card no-body class="mb-0">
        <b-table
          class="position-relative"
          :hover="true"
          :items="records"
          responsive
          :fields="fields"
          show-empty
          empty-text="No existen"
          @sort-changed="sortChanged"
        >
          <!-- Column: Created At -->
          <template #cell(created_at)="data">
            <span>{{ moment(data.item.created_at).format('YYYY-MM-DD - HH:mm') }}</span>
          </template>

          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <b-button
              size="sm"
              class=""
              @click.prevent="viewDetail(data.item)"
              v-b-tooltip.hover.top="'Ver'"
              variant="flat-info"
            >
              <feather-icon icon="EyeIcon" />
            </b-button>

            <template v-if="data.item.state === 'Despachado'">
              <b-button
                size="sm"
                @click.prevent="confirmApprove(data.item)"
                v-b-tooltip.hover.top="'Recibir'"
                variant="flat-success"
              >
                <feather-icon icon="CheckCircleIcon" />
              </b-button>
              <b-button
                size="sm"
                class=""
                @click.prevent="editDetail(data.item)"
                v-b-tooltip.hover.top="'Editar'"
                variant="flat-secondary"
              >
                <feather-icon icon="Edit2Icon" />
              </b-button>
            </template>
            
            <template v-if="data.item.state !== 'Anulado' && data.item.state !== 'Despachado' && data.item.state !== 'Cancelado' && data.item.state !== 'Aprobado' && data.item.state !== 'Observado' && data.item.state !== 'Recibido' && data.item.state !== 'Alerta'">
              <b-button
                size="sm"
                class=""
                @click.prevent="edit(data.item)"
                v-b-tooltip.hover.top="'Editar'"
                variant="flat-secondary"
              >
                <feather-icon icon="Edit2Icon" />
              </b-button>
              <b-button
                size="sm"
                class=""
                v-b-tooltip.hover.top="'Despachar'"
                @click="recivedAction(data.item)"
                variant="flat-success"
              >
                <feather-icon icon="CheckCircleIcon" />
              </b-button>
                <feather-icon icon="XCircleIcon" />
              </b-button>
            </template>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col sm="3">
              <b-form-group label-cols="4" label-cols-md="4" label-size="md" label="Entradas" label-for="input-md">
                <b-form-select
                  v-model="showEntrie"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="title"
                  :options="entries"
                  @change="changeSizePage"
                />
              </b-form-group>
            </b-col>
            <b-col sm="3" class="mt-75" style="font-size: 12px">
              <span> {{ totalElements }} Registros en total</span>
            </b-col>
            <!-- Pagination -->
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalElements"
                :per-page="showEntrie"
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
                @change="cambioPagina"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue'
import { BootstrapVue, BootstrapVueIcons, VBTooltip } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import bandejaFilters from './bandejaFilters.vue'
import InternalMovement from '@/services/InternalMovement'
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
export default {
  directives: {
    'b-tooltip': VBTooltip,
    Ripple
  },
  data() {
    return {
      showLoading: false,
      records: [],
      fields: [
        { key: 'establishmentDestiny.name', label: 'Tienda Destino', sortable: true },
        { key: 'establishmentOrigin.name', label: 'Tienda Origen', sortable: false },
        { key: 'state', label: 'Estado', sortable: true },
        { key: 'documentCode', label: 'Nro Documento', sortable: false },
        { key: 'created_at', label: 'F. Creación', sortable: false },
        { key: 'actions', label: 'Acciones' }
      ],
      arrayFilters: [],
      currentPage: 1,
      entries: [10, 20, 50, 100],
      showEntrie: 10,
      totalElements: 0,
      sort: 'id',
      order: 'desc'
    }
  },
  components:{
    bandejaFilters
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      this.records = [];
      this.totalElements = 0;
      this.showLoading = true;
    
      const datosUser = JSON.parse(localStorage.getItem('userData'));
      const userEstablishments = datosUser?.data?.userEstablishments || [];
    
      const url = `?limit=${this.showEntrie}&page=${this.currentPage}&order=${this.order}&sort=${this.sort}&filter=${JSON.stringify(this.arrayFilters)}`;
      const resp = await InternalMovement.getInternMovements(url, this.$store);
    
      if (resp.data.rows.length !== 0) {
        this.records = resp.data.rows.filter(record => 
          userEstablishments.find(est => est.id === record.establishmentDestinyId) &&
          record.state !== "Registrado" 
        );
        this.totalElements = this.records.length;
      }
      this.showLoading = false;
    },

    async recivedAction(data) {
      this.$router.push('/inventario/entrada/aceptar-destino/' + data.id)
    },

    async confirmApprove(data) {
      this.$swal({
        title: '¿Está conforme con las autopartes entregadas?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Si, conforme',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1'
        },
        buttonsStyling: false
      }).then(async (result) => {
        if (result.value) {
          const updatedData = {
            documentCode: data.documentCode,
            description: data.description,
            establishmentOriginId: data.establishmentOrigin.id,
            establishmentDestinyId: data.establishmentDestiny.id,
            state: "Recibido",
          }
          const resp = await InternalMovement.updateProcess(data.id, updatedData, this.$store)
          this.getData()
        }
      })
    },
    

    cambioPagina(e) {
      this.currentPage = e
      this.getData()
    },
    changeSizePage() {
      this.getData()
    },
    sortChanged(data) {
      this.sort = data.sortBy
      this.order = data.sortDesc ? 'desc' : 'asc'
    },

    edit(item) {
      this.$router.push('/inventario/entrada/editar/' + item.id)
    },

    editDetail(item){
      this.$router.push('/inventario/entrada/detalle/editar/' + item.id)
    },

    viewDetail(item) {
      this.$router.push('/inventario/entrada/detalle/' + item.id)
    }
  }
}
</script>
